import { App, inject } from "vue";
import { WebRgWebsocketManager } from "@/util/WebRgWebsocketManager";

const websocketManagerPlugin = Symbol();

export default {
    install(app: App, url: string) {
        app.provide(websocketManagerPlugin, new WebRgWebsocketManager(url));
    },
};

export function useWebsocketManager(): WebRgWebsocketManager {
    const auth = inject<WebRgWebsocketManager>(websocketManagerPlugin);
    if (!auth) throw new Error("WS Is null");
    return auth;
}
